// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { DeleteButton } from '@shared/ui-kit/components/delete-button';
import type { FC } from 'react';
import styles from './bank-upload-summary-list.module.css';

export interface BankUploadSummaryRowProps {
  index: number;
  testIdPrefix: string;
  title: string;
  meta: string;
  valueLabel: string;
  onOpen: (index: number) => void;
  onDelete: (index: number) => void;
}

export const BankUploadSummaryRow: FC<BankUploadSummaryRowProps> = ({
  index,
  testIdPrefix,
  title,
  meta,
  valueLabel,
  onOpen,
  onDelete,
}) => (
  <li
    className={styles['summary-row']}
    data-testid={`${testIdPrefix}-list-item-${index}`}
  >
    <div className={styles['summary-row-surface']}>
      <button
        type="button"
        className={styles['summary-row-body']}
        onClick={() => onOpen(index)}
        data-testid={`${testIdPrefix}-list-item-action-${index}`}
      >
        <span className={styles['summary-row-name']} title={title}>
          {title}
        </span>
        <span className={styles['summary-row-meta']} title={meta}>
          {meta}
        </span>
      </button>
      <span className={styles['summary-row-value']}>{valueLabel}</span>
      <DeleteButton
        onClick={event => {
          event.stopPropagation();
          onDelete(index);
        }}
        data-testid={`${testIdPrefix}-delete-${index}`}
        color="gray"
      />
    </div>
  </li>
);

BankUploadSummaryRow.displayName = 'BankUploadSummaryRow';
